import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SlotWithSequence } from "../../../../_models/planification/SlotWithSequence";
import { concatenateStrings } from "../../../../shared/utils/string.utils";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChannelService } from "../../../../_services";
import { SlotGroupWithSequence } from "../../../../_models/planification/SlotGroupWithSequence";
import { OrderStatusResponse } from "../../../../_models/orders/OrderStatusResponse";
import { SequenceDetail } from "../../../../_models/planification/SequenceDetail";
import { traductionsKeysEnum } from 'src/assets/i18n/traductionsKeysEnum';

type GridDialogData = {
   slot: SlotWithSequence | SlotGroupWithSequence,
   orderStatusList: OrderStatusResponse[],
   buttonText: { close: string },
   label: string;
}

@Component({
   selector: 'app-grid',
   templateUrl: './grid.component.html',
   styleUrls: ['./grid.component.scss']
})
export class GridComponent {
   sequence: SequenceDetail;
   closeButtonText = 'Fermer';
   slot: SlotWithSequence | SlotGroupWithSequence;
   show = true;
   label;
   duration: string;
   spotMaxNumberTrailer: string;
   spotMaxNumber: string;
   plannerStatus: string;
   form: FormGroup;
   orderStatusMap: Record<string, OrderStatusResponse>;

   constructor(
      @Inject(MAT_DIALOG_DATA) public data: GridDialogData,
      private dialogRef: MatDialogRef<GridComponent>,
      private fb: FormBuilder,
      private channelService: ChannelService,
      private cdr: ChangeDetectorRef
   ) {
      console.log("data slot", data.slot);
      if (data?.slot) {
         this.form = this.fb.group({
            durationOver: [this.data.slot.durationOver, Validators.required],
            spotMaxNumberOver: [this.data.slot.spotMaxNumberOver, Validators.required],
            spotMaxNumberTrailerOver: [this.data.slot.spotMaxNumberTrailerOver, Validators.required],
            plannerStatusOver: [this.data.slot.plannerStatusOver, Validators.required]
         });
         this.slot = data.slot;
         this.duration = concatenateStrings([this.slot.duration || '...', this.slot.durationOver || '...'], '/', undefined, "s");
         this.spotMaxNumberTrailer = concatenateStrings([this.slot.spotMaxNumberTrailer || '...', this.slot.spotMaxNumberTrailerOver || '...'], '/');
         this.spotMaxNumber = concatenateStrings([this.slot.spotMaxNumber || '...', this.slot.spotMaxNumberOver || '...'], '/');
         this.plannerStatus = concatenateStrings([this.slot.plannerStatus || '...', this.slot.plannerStatusOver || '...'], '/');
      }

      if (data?.label) {
         this.label = data.label;
      }

      if (data?.buttonText) {
         this.closeButtonText = data.buttonText.close || this.closeButtonText;
      }

      if (data?.orderStatusList) {
         this.orderStatusMap = data.orderStatusList.reduce<Record<string, OrderStatusResponse>>(
            (acc, item) => ({ ...acc, [item.code]: item }), {}
         );
      }
   }

   isSlotWithSequence(slot: SlotGroupWithSequence | SlotWithSequence): slot is SlotWithSequence {
      return 'slotId' in slot;
   }

   isSlotGroupWithSequence(slot: SlotGroupWithSequence | SlotWithSequence): slot is SlotGroupWithSequence {
      return 'sequenceGroups' in slot;
   }

   hasSlotStatus(slot: any): any {
      console.log(slot);
      if (slot.sequenceGroups) {
         var seq = slot.sequenceGroups.find(seq => seq.status === '00:Option');
         if (seq)
            return true;
      }
      return false;
   }

   overrideSlot(slotInfo: {
      label: string,
      value: string
   }) {
      if (this.isSlotWithSequence(this.data.slot)) {
         const screenOverRequest = {
            screenIds: [this.data.slot.slotId],
            durationOver: parseInt(this.form.value.durationOver),
            spotMaxNumberOver: parseInt(this.form.value.spotMaxNumberOver),
            spotMaxNumberTrailerOver: parseInt(this.form.value.spotMaxNumberTrailerOver),
            plannerStatusOver: this.form.value.plannerStatusOver
         };
         this.channelService.overrideSlot(screenOverRequest).subscribe(_ => {
            this.setSlotInfo(slotInfo);
            this.cdr.detectChanges();
         });
      }

      if (this.isSlotGroupWithSequence(this.data.slot)) {
         const screenGroupOverRequest = {
            screenGroupIds: [this.data.slot.id],
            durationOver: parseInt(this.form.value.durationOver),
            spotMaxNumberOver: parseInt(this.form.value.spotMaxNumberOver),
            spotMaxNumberTrailerOver: parseInt(this.form.value.spotMaxNumberTrailerOver),
            plannerStatusOver: this.form.value.plannerStatusOver
         };

         this.channelService.overrideSlotGroup(screenGroupOverRequest).subscribe(_ => {
            this.setSlotInfo(slotInfo);
            this.cdr.detectChanges();
         });
      }

      this.slot = {
         ...this.slot,
         spotMaxNumberOver: this.form.value.spotMaxNumberOver,
         spotMaxNumberTrailerOver: this.form.value.spotMaxNumberTrailerOver,
         plannerStatusOver: this.form.value.plannerStatusOver
      }
   }

   setSlotInfo(slotInfo: {
      label: string,
      value: string
   }) {
      switch (slotInfo.label) {
         case 'durationOver':
            this.duration = concatenateStrings([this.slot.duration || '...', slotInfo.value || '...'], '/', undefined, "s");
            break;
         case 'spotMaxNumberOver':
            this.spotMaxNumber = concatenateStrings([this.slot.spotMaxNumber || '...', slotInfo.value || '...'], '/');
            break;
         case 'spotMaxNumberTrailerOver':
            this.spotMaxNumberTrailer = concatenateStrings([this.slot.spotMaxNumberTrailer || '...', slotInfo.value || '...'], '/');
            break;
         case 'plannerStatusOver':
            this.plannerStatus = concatenateStrings([this.slot.plannerStatus || '...', slotInfo.value || '...'], '/');
            break;
      }
   }

   getColor(usedRate: number) {
      if (usedRate === 0) {
         return '#04AA6D';
      } else if (usedRate === 1) {
         return '#708090';
      } else {
         return '#f69d3c';
      }
   }

   round2(usedRate: number) {
      return Math.round(Math.min(usedRate, 1) * 100)
   }

   calculUsedRate(usedRate: number, usedRate1: number) {
      return (1 * (usedRate)) / (usedRate + usedRate1)
   }

   calculSemiUsedRate(usedRate: number, usedRate1: number) {
      return (1 * (usedRate1)) / (usedRate + usedRate1)
   }

   closeDialog() {
      this.dialogRef.close(this.slot);
   }

     protected readonly traductionsKeysEnum = traductionsKeysEnum;
}
